import { useSearchParams } from 'react-router-dom';
import { EQUIPMENT_IMAGE_TYPE } from 'utils/attachments';
import { existingEquipmentUploadContent } from './public-image-upload-content';
import PublicImageUploadPage from './public-image-upload-page';

export default function ExistingEquipmentImagesPage() {
  const [searchParams] = useSearchParams();
  const structureUniqueId = searchParams.get('sid');

  return (
    <PublicImageUploadPage
      structureUniqueId={structureUniqueId}
      imageType={EQUIPMENT_IMAGE_TYPE}
      {...existingEquipmentUploadContent}
    />
  );
}
